"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusTag = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/tag/tag");
const tag_styles_1 = require("@/components/common/tag/tag.styles");
const tag_utils_1 = require("@/components/common/tag/tag.utils");
let StatusTag = class StatusTag extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.variant = 'neutral';
    }
    render() {
        const tone = tag_styles_1.statusToneMap[this.variant];
        return (0, tag_utils_1.renderTag)(tone, this.icon, this.variant);
    }
};
__decorate([
    (0, decorators_js_1.property)({ type: String })
], StatusTag.prototype, "variant", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], StatusTag.prototype, "icon", void 0);
StatusTag = __decorate([
    (0, decorators_js_1.customElement)('mm-status-tag')
], StatusTag);
exports.StatusTag = StatusTag;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhdHVzLXRhZy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInN0YXR1cy10YWcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQWdDO0FBQ2hDLHFEQUEyRDtBQUkzRCx1Q0FBb0M7QUFDcEMsbUVBQXlGO0FBQ3pGLGlFQUE2RDtBQUd0RCxJQUFNLFNBQVMsR0FBZixNQUFNLFNBQVUsU0FBUSxnQkFBVTtJQUFsQzs7UUFDdUIsWUFBTyxHQUFxQixTQUFTLENBQUE7SUFPbkUsQ0FBQztJQUpDLE1BQU07UUFDSixNQUFNLElBQUksR0FBRywwQkFBYSxDQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsQ0FBQTtRQUN4QyxPQUFPLElBQUEscUJBQVMsRUFBQyxJQUFJLEVBQUUsSUFBSSxDQUFDLElBQUksRUFBRSxJQUFJLENBQUMsT0FBTyxDQUFDLENBQUE7SUFDakQsQ0FBQztDQUNGLENBQUE7QUFQNkI7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDOzBDQUFzQztBQUNyQztJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7dUNBQWdCO0FBRmhDLFNBQVM7SUFEckIsSUFBQSw2QkFBYSxFQUFDLGVBQWUsQ0FBQztHQUNsQixTQUFTLENBUXJCO0FBUlksOEJBQVMifQ==